import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "name", "value", "step", "min", "max", "error", "placeholder"]
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "tel",
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.numberValue,
      class: _normalizeClass(["c-input-number", {
        'c-input-number--error': _ctx.error,
        'c-input-number--has_icon': _ctx.hasIcon,
        'c-input-number--has_suffix': _ctx.hasSuffix
      }]),
      step: _ctx.step,
      min: _ctx.min,
      max: _ctx.max,
      error: _ctx.error,
      placeholder: _ctx.placeholder,
      onKeypress: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.validateValue && _ctx.validateValue(...args))),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
    }, null, 42, _hoisted_1),
    (_ctx.$slots.lastLabel)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "lastLabel", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}